// ================================================================
// WARNING: HERE LIES UNSAFE CODE. EXCERCISE EXTREME CAUTION.
// It's possible to preview a member's results locally by making changes to this file
// 1. Copy the "production" environment to "development"
// 2. Use the planetscale client to create a tunnel to the prod database
// 3. Update your .env file to point to the prod database tunnel
// 4. Make the changes documented in the queries.ts file
// 5. Make thc changes documented in the /pages/account/reports/[identifier].ts file
// 6. You may need to add a row to the planetscale database for the report if it's not yet locked
// ================================================================
const healthie = Object.freeze({
  development: {
    healthie_forms: {
      INTAKE_ASSESSMENT: '25005',
      CLINICAL_RX_RECOMMENDATION: '25180',
      ASYNC_CONSULTATION: '25118',
      BLOOD_TEST_RESULTS: '25179',
      CLINICAL_INTAKE_ASSESSMENT: '25056',
      TELEHEALTH_CONSENT: '24982',
    },
    embed: {
      CLINICAL_INTAKE_ASSESSMENT:
        'https://securestaging.gethealthie.com/appointments/embed_appt?dietitian_id=26094&embed_form_id=25056&form_only=true',
      TELEHEALTH_CONSENT:
        'https://securestaging.gethealthie.com/appointments/embed_appt?dietitian_id=26094&embed_form_id=24982&form_only=true',
      FIND_DOCTOR:
        'https://securestaging.gethealthie.com/appointments/embed_appt?dietitian_id=29739&appt_type_ids=[19414]&org_level=true',
    },
    RX_CLINICAL_ALLOWED_PHARMACEUTICALS_NOTE_MODULE_ID: '343137',
    RX_CLINICAL_PROGRAM_RECOMMENDATION_NOTE_MODULE_ID: '343140',
    ASYNC_CONSULTATION_PROGRAM_RECOMMENDATION_NOTE_MODULE_ID: '336606',
    RX_CLINICAL_RECOMMENDATION_DOCTOR_NOTE_MODULE_ID: '343128',
    ASYNC_CONSULTATION_DOCTOR_NOTE_MODULE_ID: '336609',
  },
  preview: {
    healthie_forms: {
      INTAKE_ASSESSMENT: '25005',
      CLINICAL_RX_RECOMMENDATION: '25180',
      ASYNC_CONSULTATION: '25118',
      BLOOD_TEST_RESULTS: '25179',
      CLINICAL_INTAKE_ASSESSMENT: '25056',
      TELEHEALTH_CONSENT: '24982',
    },
    embed: {
      CLINICAL_INTAKE_ASSESSMENT:
        'https://securestaging.gethealthie.com/appointments/embed_appt?dietitian_id=26094&embed_form_id=25056&form_only=true',
      TELEHEALTH_CONSENT:
        'https://securestaging.gethealthie.com/appointments/embed_appt?dietitian_id=26094&embed_form_id=24982&form_only=true',
      FIND_DOCTOR:
        'https://securestaging.gethealthie.com/appointments/embed_appt?dietitian_id=29739&appt_type_ids=[19414]&org_level=true',
    },
    RX_CLINICAL_ALLOWED_PHARMACEUTICALS_NOTE_MODULE_ID: '343137',
    RX_CLINICAL_PROGRAM_RECOMMENDATION_NOTE_MODULE_ID: '343140',
    ASYNC_CONSULTATION_PROGRAM_RECOMMENDATION_NOTE_MODULE_ID: '336606',
    RX_CLINICAL_RECOMMENDATION_DOCTOR_NOTE_MODULE_ID: '343128',
    ASYNC_CONSULTATION_DOCTOR_NOTE_MODULE_ID: '336609',
  },
  production: {
    healthie_forms: {
      CLINICAL_INTAKE_ASSESSMENT: '567696',
      BLOOD_TEST_RESULTS: '567671',
      CLINICAL_RX_RECOMMENDATION: '567345',
      ASYNC_CONSULTATION: '547629',
      INTAKE_ASSESSMENT: '567649',
      TELEHEALTH_CONSENT: '463790',
    },
    embed: {
      CLINICAL_INTAKE_ASSESSMENT:
        'https://secure.gethealthie.com/appointments/embed_appt?dietitian_id=1252837&embed_form_id=567696&form_only=true',
      TELEHEALTH_CONSENT:
        'https://secure.gethealthie.com/appointments/embed_appt?dietitian_id=1252837&embed_form_id=463790&form_only=true',
      FIND_DOCTOR:
        'https://secure.gethealthie.com/appointments/embed_appt?dietitian_id=1260500&appt_type_id=163410&org_level=true&vorp_ezimodnar=true'
    },
    RX_CLINICAL_ALLOWED_PHARMACEUTICALS_NOTE_MODULE_ID: '9097947',
    //RX_CLINICAL_PROGRAM_RECOMMENDATION_NOTE_MODULE_ID: '9268174',
    RX_CLINICAL_PROGRAM_RECOMMENDATION_NOTE_MODULE_ID: '9425642',
    ASYNC_CONSULTATION_PROGRAM_RECOMMENDATION_NOTE_MODULE_ID: '8875010',
    RX_CLINICAL_RECOMMENDATION_DOCTOR_NOTE_MODULE_ID: '9097942',
    ASYNC_CONSULTATION_DOCTOR_NOTE_MODULE_ID: '8875008',
  },
})

export default healthie[process.env.VERCEL_ENV]
